/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/reportPortalMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a ReportPortal. */
export class ReportPortal {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a ReportPortal.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.ReportPortalGetMonthlyBalanceResponse>
   */
  getMonthlyBalance(options?: Models.ReportPortalGetMonthlyBalanceOptionalParams): Promise<Models.ReportPortalGetMonthlyBalanceResponse>;
  /**
   * @param callback The callback
   */
  getMonthlyBalance(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getMonthlyBalance(options: Models.ReportPortalGetMonthlyBalanceOptionalParams, callback: msRest.ServiceCallback<void>): void;
  getMonthlyBalance(options?: Models.ReportPortalGetMonthlyBalanceOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<Models.ReportPortalGetMonthlyBalanceResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getMonthlyBalanceOperationSpec,
      callback) as Promise<Models.ReportPortalGetMonthlyBalanceResponse>;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.ReportPortalGetGeneralBalanceResponse>
   */
  getGeneralBalance(options?: Models.ReportPortalGetGeneralBalanceOptionalParams): Promise<Models.ReportPortalGetGeneralBalanceResponse>;
  /**
   * @param callback The callback
   */
  getGeneralBalance(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getGeneralBalance(options: Models.ReportPortalGetGeneralBalanceOptionalParams, callback: msRest.ServiceCallback<void>): void;
  getGeneralBalance(options?: Models.ReportPortalGetGeneralBalanceOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<Models.ReportPortalGetGeneralBalanceResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getGeneralBalanceOperationSpec,
      callback) as Promise<Models.ReportPortalGetGeneralBalanceResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const getMonthlyBalanceOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/report/monthlyBalance",
  queryParameters: [
    Parameters.year1,
    Parameters.month1,
    Parameters.detailedReport,
    Parameters.paymentDateFrom,
    Parameters.paymentDateTo,
    Parameters.pharmaciesIds,
    Parameters.sieveFilters,
    Parameters.sieveSorts,
    Parameters.sievePage,
    Parameters.sievePageSize,
    Parameters.isCheckedAll,
    Parameters.checked,
    Parameters.unchecked,
    Parameters.fileType
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Stream"
        }
      }
    },
    default: {}
  },
  serializer
};

const getGeneralBalanceOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/report/generalBalance",
  queryParameters: [
    Parameters.year1,
    Parameters.monthFrom,
    Parameters.monthTo,
    Parameters.paymentDateFrom,
    Parameters.paymentDateTo,
    Parameters.pharmaciesIds,
    Parameters.sieveFilters,
    Parameters.sieveSorts,
    Parameters.sievePage,
    Parameters.sievePageSize,
    Parameters.isCheckedAll,
    Parameters.checked,
    Parameters.unchecked,
    Parameters.fileType
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Stream"
        }
      }
    },
    default: {}
  },
  serializer
};
